import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { POLICIES, Policy } from "../../data/policies";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 10px 20px 40px;
  background-color: #fff;
  min-height: 100vh;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #333;
  color: #333;
`;

const Content = styled.div`
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  word-break: keep-all;

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: #1a73e8;
    margin: 32px 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
  }

  h3 {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin: 24px 0 12px 0;
  }

  p {
    margin: 12px 0;
    text-align: justify;
  }

  .indent {
    padding-left: 20px;
  }

  .indent2 {
    padding-left: 40px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: 13px;
  }

  th {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    padding: 10px 8px;
    text-align: center;
    font-weight: bold;
  }

  td {
    border: 1px solid #ddd;
    padding: 10px 8px;
    text-align: left;
  }

  .notice {
    background-color: #f9f9f9;
    padding: 16px;
    border-left: 4px solid #1a73e8;
    margin: 16px 0;
  }

  .footer {
    margin-top: 32px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    font-size: 13px;
    color: #666;
  }
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 16px;
  color: #666;
`;

const PolicyPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [policy, setPolicy] = useState<Policy | null>(null);

  useEffect(() => {
    if (id && POLICIES[Number(id)]) {
      setPolicy(POLICIES[Number(id)]);
    }
  }, [id]);

  if (!policy) {
    return (
      <Container>
        <ErrorMessage>정책을 찾을 수 없습니다.</ErrorMessage>
      </Container>
    );
  }

  return (
    <Container>
      <Title>{policy.title}</Title>
      <Content dangerouslySetInnerHTML={{ __html: policy.content }} />
    </Container>
  );
};

export default PolicyPage;
